import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";


interface Props extends PopupProps {
    employeeId: number
}
interface EmployeeFunctionalRoleCreateModel {
    employeeId: number
    functionalRoleId: number
}

const AddEmployeeFunctionalRolePopup: React.FC<Props> = ({ show, onHide, employeeId }) => {
    const [serverErrors, setServerErrors] = useState<DataResult<EmployeeFunctionalRoleCreateModel>>({ isSuccesful: true, messages: [], data: undefined });
    const [formData, setFormData] = useState<EmployeeFunctionalRoleCreateModel>({
        employeeId: employeeId,
        functionalRoleId: 0,
    });

    const roles = useSelectListOptions('api/v1/selectlist/FunctionalRoles', '-- Select role');
    const { handleResult, handleException } = useNotifications();


    function submit() {
        if (formData) {
            DataService
                .create<EmployeeFunctionalRoleCreateModel>(`api/v1/EmployeeFunctionalRoles`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        if (onHide)
                            onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    function onFieldChanged(name: string, value: string): void {
        formData[name] = value;
        setFormData(formData);
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'functionalRoleId', label: 'Role', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        handleFieldChanged: onFieldChanged,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add Role'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('functionalRoleId')} options={roles} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton text='Add' {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default AddEmployeeFunctionalRolePopup;